import moment from "moment";
import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { NEW_PAYMENT_TYPE } from "../../../../../enums/OrderEnums";
import { PAYMENT_STATUS } from "../../../../../enums/PaymentEnums";
import { vendorDashboardfromAdmin } from "../../../../../store/actions/vendorAccessActions";
import { SecondLevelInfoExp } from "../TableBody";

const TableBody = ({ data, type, onStatusChange }) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = async () => {
    setTrDetail(!TrDetail);
  };
  const history = useHistory();

  const dispatch = useDispatch();
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td
          className="p-0 w-100"
          ref={(element) => {
            if (element)
              element.style.setProperty("padding", "0px", "important");
          }}
        >
          <table className="w-100">
            <tbody className="seating-dashboard-body-new">
              <tr
                style={{
                  border: "none",
                  borderRadius: "5px 0px 0px 5px",
                  borderLeft: `1.0708vw solid #8972DF`,
                }}
                className="sd_body_table-row p-0"
                onClick={showTr}
              >
                <td
                  style={{ width: "2%" }}
                  className="table-body-left-vertical-badge-td"
                >
                  <div
                    className="f9-500"
                    style={{ letterSpacing: 1, marginLeft: "-1rem" }}
                  >
                    {data?.experienceId?.subCategory?.title?.toUpperCase()}
                  </div>
                </td>
                <td style={{ width: "18%" }}>
                  <div className="vendor-main-section-one">
                    <div>
                      <h5 className="font_16_m mt-2">
                        {data?.restaurantId?.restaurant_name}
                      </h5>
                      <div className="f12-500">{data?.restaurantId?.city}</div>
                      <div className="f12-400">#{data?.restaurantId?._id}</div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="start-rating-review-box mt-2">
                    <div className="f14-500 ">{data?.userDetails?.name}</div>
                    <div className="f12-500 text-red">#{data?.requestId}</div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="total-pax-body">
                    <div className="col d-flex p-0">
                      <div className="total-pax-body-inside">
                        <h4 className="font_24_b">
                          {data?.adultCount + data?.kidsCount + data?.package?.adults + data?.package?.kids}
                        </h4>
                        {/* <p className="total-pax-light-text">PAX</p> */}
                      </div>
                      <div className="total-adult-kids">
                        {data?.adultCount ? (
                          <div className="display-align">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/image/adult.svg")}
                              alt="Adult"
                              title="Adult"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {data?.adultCount}
                            </p>
                          </div>
                        ) : null}
                        {data?.kidsCount ? (
                          <div className="display-align">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/image/kids.svg")}
                              alt="Kids"
                              title="Kids"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {data?.kidsCount}
                            </p>
                          </div>
                        ) : null}
                      </div>
                      <div className="total-highchair-handicapp">
                        {data?.highChair === 0 ? null : (
                          <div className="display-align">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/image/highchair.svg")}
                              alt="Highchair"
                              title="Highchair"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {data?.highChair}
                            </p>
                          </div>
                        )}
                        {data?.handicapChair === 0 ? null : (
                          <div className="display-align">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/image/handicap.svg")}
                              alt="Handicapped"
                              title="Handicapped"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {data?.handicapChair}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f14-500">
                    {data?.createdAt
                      ? moment(data?.createdAt).format("Do MMM YYYY")
                      : ""}
                    <br />
                    {data?.createdAt
                      ? moment(data?.createdAt).format("HH:MM A")
                      : ""}
                  </div>
                </td>
                <td
                  className="text-center"
                  style={{
                    width: "20%",
                  }}
                >
                  <span className="f12-500 d-flex align-items-center justify-content-center">
                    <i className="fa fa-inr mr-1" aria-hidden="true"></i>

                    <div className="d-flex ml-1 align-items-center">
                      {data?.paymentData?.totalAmount} |{" "}
                      <div
                        className=" f10-500 ml-1"
                        style={{
                          color:
                            data?.paymentStatus === 1 ? "#3E9121" : "#000000",
                        }}
                      >
                        {data?.paymentStatus === 1
                          ? "PAID"
                          : data?.paymentStatus === 0
                            ? "UNPAID"
                            : data?.paymentStatus === 3
                              ? "FAILURE"
                              : "N/A"}
                      </div>
                    </div>

                  </span>
                  <hr className="my-1" />
                  {data.paymentStatus !== 1 ? (
                    data.status === "CANCELLED" ? (
                      ""
                    ) : (
                      <div className="mt-1 mb-1 text-center">
                        <button
                          className="btn bg-danger text-white f10-400 px-2 py-1"
                          onClick={
                            () => { }
                            // onClickPayLater(props.orderDetails)
                          }
                        >
                          Pay Now
                        </button>
                      </div>
                    )
                  ) : (
                    ""
                  )}
                  <div className="text-center">
                    <div className="f12-500">
                      {data?.splitPayment ? (
                        <>Split Payment</>
                      ) : (
                        NEW_PAYMENT_TYPE[data.paymentData?.paymentMethod]
                      )}
                    </div>
                  </div>
                </td>
                <td style={{ width: "8%" }}>
                  {" "}
                  <div className="f14-500">
                    {data?.seatingPreference.join(",")}
                  </div>
                </td>
                <td style={{ width: "8%" }}>
                  <div className="f14-500">{data?.status || "PENDING"}</div>
                </td>
                <td
                  style={{ width: "14%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <button
                    onClick={() =>
                      dispatch(
                        vendorDashboardfromAdmin(
                          data?.restaurantId?.vendor_id,
                          () => {
                            history.push(
                              type ? "/curatedDashboard" : "/specialDashboard", { path: type }
                            );
                          }
                        )
                      )
                    }
                    className="enViewDashboard btn btn-outline-danger d-flex align-items-center"
                  >
                    <Image
                      src={require("../../../../../assets/images/ActionImages/image/onboarding.svg")}
                      alt="View"
                      title="View"
                      fluid
                      className="mr-2"
                      width="20px"
                    />
                    <div className="f9-500">View Dashboard</div>
                  </button>
                </td>
              </tr>
              {TrDetail && (
                <>
                  <SecondLevelInfoExp
                    data={data}
                    onStatusChange={onStatusChange}
                  />
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default TableBody;
